import { Box, Container, Typography, Paper } from '@mui/material';

export default function TermsOfServicePage() {
  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: '#f5f5f5', py: 6 }}>
      <Container maxWidth="md">
        <Paper sx={{ p: 5, borderRadius: 3 }}>
          <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>서비스 이용약관</Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>최종 수정일: 2026년 2월 10일</Typography>

          <Typography variant="h6" sx={{ fontWeight: 700, mt: 3, mb: 1 }}>제1조 (목적)</Typography>
          <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.8 }}>
            본 약관은 주식회사 케이지네트워크(이하 "회사")가 제공하는 KOAI 서비스(이하 "서비스")의 이용과 관련하여 회사와 이용자 간의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 700, mt: 3, mb: 1 }}>제2조 (정의)</Typography>
          <Box component="ol" sx={{ pl: 3, mb: 2 }}>
            <li><Typography variant="body1">"서비스"란 회사가 제공하는 AI 기반 채팅, 문서 처리, 팀 협업 등의 모든 서비스를 의미합니다.</Typography></li>
            <li><Typography variant="body1">"이용자"란 본 약관에 따라 회사가 제공하는 서비스를 이용하는 회원 및 비회원을 말합니다.</Typography></li>
            <li><Typography variant="body1">"회원"이란 회사와 서비스 이용계약을 체결하고 회원 아이디(ID)를 부여받은 자를 말합니다.</Typography></li>
            <li><Typography variant="body1">"AI 생성 콘텐츠"란 인공지능 모델이 생성한 텍스트, 이미지 등의 콘텐츠를 말합니다.</Typography></li>
          </Box>

          <Typography variant="h6" sx={{ fontWeight: 700, mt: 3, mb: 1 }}>제3조 (약관의 효력 및 변경)</Typography>
          <Box component="ol" sx={{ pl: 3, mb: 2 }}>
            <li><Typography variant="body1">본 약관은 서비스를 이용하고자 하는 모든 이용자에 대하여 그 효력을 발생합니다.</Typography></li>
            <li><Typography variant="body1">회사는 필요한 경우 관련 법령을 위배하지 않는 범위 내에서 본 약관을 변경할 수 있으며, 약관이 변경되는 경우 변경사항을 시행일자 7일 전부터 공지합니다.</Typography></li>
            <li><Typography variant="body1">이용자가 변경된 약관에 동의하지 않는 경우, 서비스 이용을 중단하고 탈퇴할 수 있습니다.</Typography></li>
          </Box>

          <Typography variant="h6" sx={{ fontWeight: 700, mt: 3, mb: 1 }}>제4조 (회원가입)</Typography>
          <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.8 }}>
            이용자는 회사가 정한 가입 양식에 따라 회원정보를 기입한 후 본 약관에 동의한다는 의사표시를 함으로써 회원가입을 신청합니다.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 700, mt: 3, mb: 1 }}>제5조 (서비스의 제공 및 변경)</Typography>
          <Box component="ul" sx={{ pl: 3, mb: 2 }}>
            <li><Typography variant="body1">AI 기반 채팅 서비스</Typography></li>
            <li><Typography variant="body1">문서 업로드 및 AI 분석 서비스</Typography></li>
            <li><Typography variant="body1">팀 협업 및 주제방 관리 서비스</Typography></li>
            <li><Typography variant="body1">기타 회사가 추가 개발하거나 다른 회사와의 제휴 계약 등을 통해 제공하는 일체의 서비스</Typography></li>
          </Box>

          <Typography variant="h6" sx={{ fontWeight: 700, mt: 3, mb: 1 }}>제6조 (서비스의 중단)</Typography>
          <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.8 }}>
            회사는 컴퓨터 등 정보통신설비의 보수점검, 교체 및 고장, 통신의 두절 등의 사유가 발생한 경우에는 서비스의 제공을 일시적으로 중단할 수 있습니다.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 700, mt: 3, mb: 1 }}>제7조 (회원의 의무)</Typography>
          <Typography variant="body1" sx={{ mb: 1 }}>회원은 다음 행위를 하여서는 안 됩니다:</Typography>
          <Box component="ol" sx={{ pl: 3, mb: 2 }}>
            <li><Typography variant="body1">신청 또는 변경 시 허위내용의 등록</Typography></li>
            <li><Typography variant="body1">타인의 정보 도용</Typography></li>
            <li><Typography variant="body1">회사가 게시한 정보의 변경</Typography></li>
            <li><Typography variant="body1">회사와 기타 제3자의 저작권 등 지적재산권에 대한 침해</Typography></li>
            <li><Typography variant="body1">AI 서비스를 악용하여 유해 콘텐츠를 생성하거나 타인에게 피해를 주는 행위</Typography></li>
          </Box>

          <Typography variant="h6" sx={{ fontWeight: 700, mt: 3, mb: 1 }}>제8조 (AI 서비스 이용 관련 특칙) - AI기본법 준수</Typography>
          <Box component="ol" sx={{ pl: 3, mb: 2 }}>
            <li><Typography variant="body1">회사는 AI 서비스 제공 사실을 이용자에게 명확히 고지하며, AI 생성 콘텐츠에는 "AI 생성" 표시를 부착합니다.</Typography></li>
            <li><Typography variant="body1">AI 생성 콘텐츠는 오류, 편향, 부정확한 정보를 포함할 수 있으며, 이용자는 이를 인지하고 서비스를 이용해야 합니다.</Typography></li>
            <li><Typography variant="body1">이용자가 업로드한 파일은 AI 처리(임베딩) 후 개인정보 보호를 위해 즉시 삭제됩니다.</Typography></li>
          </Box>

          <Typography variant="h6" sx={{ fontWeight: 700, mt: 3, mb: 1 }}>제9조 (저작권의 귀속 및 이용제한)</Typography>
          <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.8 }}>
            회사가 작성한 저작물에 대한 저작권 기타 지적재산권은 회사에 귀속합니다. AI 생성 콘텐츠의 저작권은 관련 법령에 따라 처리됩니다.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 700, mt: 3, mb: 1 }}>제10조 (면책조항)</Typography>
          <Box component="ol" sx={{ pl: 3, mb: 2 }}>
            <li><Typography variant="body1">회사는 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 책임이 면제됩니다.</Typography></li>
            <li><Typography variant="body1">회사는 AI 생성 콘텐츠의 정확성, 신뢰성, 적법성에 대해 보증하지 않습니다.</Typography></li>
          </Box>

          <Typography variant="h6" sx={{ fontWeight: 700, mt: 3, mb: 1 }}>제11조 (분쟁의 해결)</Typography>
          <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.8 }}>
            회사와 이용자는 서비스와 관련하여 발생한 분쟁을 원만하게 해결하기 위하여 필요한 모든 노력을 하여야 합니다.
          </Typography>

          <Typography variant="body1" sx={{ mt: 3, mb: 2 }}>
            <strong>부칙:</strong> 본 약관은 2026년 2월 10일부터 시행됩니다.
          </Typography>

          <Box sx={{ mt: 4, pt: 3, borderTop: '1px solid #e0e0e0' }}>
            <Typography variant="body2" color="text.secondary">주식회사 케이지네트워크 | 대표이사: 김대경</Typography>
            <Typography variant="body2" color="text.secondary">경기도 부천시 은성로32 비1층(소사본동)</Typography>
            <Typography variant="body2" color="text.secondary">사업자등록번호: 747-87-02879 | 통신판매업 신고번호: 제 2024-부천소사-0543 호</Typography>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
}
